<div class="menu_box">
  <ng-container *ngIf="!currentUser?.role?.includes('operator') else operatorLogo">
    <!-- <img class="logo" src="assets/images/logo_small.svg" alt="Mallorcab logo" routerLink=""> -->
    <ion-icon class="logo" src="assets/images/logo_small.svg"></ion-icon>
  </ng-container>
  <ng-template #operatorLogo>
    <ion-icon class="logo operator" [ngClass]="connectionStatus" src="assets/images/callcenter_logo.svg"></ion-icon>
    <div class="operator_name">{{ currentUser?.name }}</div>
  </ng-template>
  <div class="lists">
    <ion-list>
      <ion-menu-toggle auto-hide="false" *ngFor="let page of pagesList; let i = index">
        <ng-container *ngIf="i < 12">
          <ion-button fill="clear" routerDirection="root" [routerLink]="'/' + page" lines="none" detail="false"
            routerLinkActive="selected" [routerLinkActiveOptions]="{exact : page ? false : true}">
            <div class="item_box">
              <ion-icon aria-hidden="true"
                [name]="(page === 'price-simulator' ? 'dp-stats' : ('dp-' + ((page.includes('tabs/') ? page.replace('tabs/', '') : page) || 'home')))"></ion-icon>
              <div class="page_name">{{ 'menu.' + (page || 'home') | translate }}</div>
            </div>
          </ion-button>
        </ng-container>
      </ion-menu-toggle>
    </ion-list>

    <ion-list>
      <ion-menu-toggle auto-hide="false" *ngFor="let page of pagesList; let i = index">
        <ng-container *ngIf="i > 11">
          <ion-button fill="clear" routerDirection="root" [routerLink]="'/' + page" lines="none" detail="false"
            routerLinkActive="selected">
            <div class="item_box">
              <ion-icon aria-hidden="true" [name]="(page === 'price-simulator' ? 'dp-stats' : ('dp-' + page))"></ion-icon>
              <div class="page_name">{{ 'menu.' + page | translate }}</div>
            </div>
          </ion-button>
        </ng-container>
      </ion-menu-toggle>
      <ion-menu-toggle auto-hide="false">
        <ion-button fill="clear" lines="none" detail="false" routerLinkActive="selected" (click)="logout()">
          <div class="item_box">
            <ion-icon aria-hidden="true"
              [name]="connectionStatus === 'connected' ? 'dp-logout' : 'dp-close'"></ion-icon>
            <div class="page_name">{{ 'menu.logout' | translate }}</div>
          </div>
        </ion-button>
        <ion-button fill="clear" lines="none" detail="false" (click)="openLogsModal()"
          *ngIf="currentUser?.role?.includes('operator')">
          <div class="item_box">
            <ion-icon aria-hidden="true" name="document-text-outline"></ion-icon>
            <div class="page_name">Logs</div>
          </div>
        </ion-button>
      </ion-menu-toggle>
    </ion-list>
  </div>
</div>